import type { QueryResult } from '@/types';

export function ResultTable({ result }: { result: QueryResult }) {
  return (
    <div className="overflow-auto rounded-DEFAULT border border-line">
      <table className="result-table">
        <thead>
          <tr>
            {result.columns.map((col) => (
              <th key={col}>{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {result.rows.map((row, ri) => (
            <tr key={ri}>
              {row.map((cell, ci) => (
                <td key={ci}>
                  {cell === null ? <span className="italic text-content-muted">NULL</span> : String(cell)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
